import { client } from "../utils/netlify";

export const analyzeUserPrompt = async (user_input, user_id, ga_session_id) => {
  try {
    // Make the request to the analyze-user-prompt endpoint
    const response = await client("analyze-user-prompt", { user_input, user_id, ga_session_id });

    // Await the response
    const result = await response;

    console.log(result, 'result analyzeUserPrompt=====')

    // Return the algoliaUrl if it exists, otherwise return an empty string
    if(result?.error) {
      console.log(result, 'result error analyzeUserPrompt=====')
      return result;
    }

    return result.algoliaUrl || 'no-result';
  } catch (error) {
    // Handle any errors
    console.error("Error in analyzeUserPrompt:", error);
    throw error;
  }
};

export const getOliStatus = async () => {
  try {
    // Make the request to the get-oli-status endpoint
    const response = await client("get-oli-status");

    // Await the response
    const result = await response;

    // Return the oli status
    return result.status || false;
  } catch (error) {
    // Handle any errors
    reportError("Error in getOliStatus");
    reportError(error)
  }
}

export const analyzePromptFeedback = async (ga_session_id, feedback) => {
  try {
    // Make the request to the analyze-user-prompt endpoint
    const response = await client("analyze-prompt-feedback", { ga_session_id, feedback });

    // Await the response
    const result = await response;

    // Return the oli status
    return result.status || false;
  } catch (error) {
    // Handle any errors
    console.error("Error in analyzeUserPrompt:", error);
    throw error;
  }
}
